// src/pages/productivityplanner/index.jsx  (apne actual path pe rakho)
import React, { useEffect, useState } from "react";
import CollectionPage from "./Collectionpage";
import { getProductivityPlanners, PRODUCTS_PER_PAGE } from "../data/Productivityplanners";
import SEOHead from "../components/common/SEOHead";
import ProductListSchema from "../components/common/ProductListSchema";
import FAQSchema from "../components/common/FAQSchema";

const PAGE_URL = "https://aishcraft.com/productivityplanner";

const productivityPlannerFAQs = [
  {
    question: "What makes a productivity planner different from a regular planner?",
    answer: "Productivity planners include goal trackers, time-blocking sections, and project planning pages designed to boost focus and efficiency.",
  },
  {
    question: "Can I personalize the cover with my name?",
    answer: "Yes, every planner can be customized with your name, initials, or a custom message on the cover.",
  },
  {
    question: "How long does delivery take?",
    answer: "Personalized planners are made to order and typically ship within 6 working days across India.",
  },
];

export default function Productivityplanner() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getProductivityPlanners()
      .then(setProducts)
      .catch((err) => setError(err.message || "Failed to load products"));
  }, []);

  const seo = (
    <SEOHead
      title="Productivity Planners | Personalized Planners"
      description="Shop premium productivity planners with goal trackers, time blocks & project planners. Built for people who mean business."
      url={PAGE_URL}
      breadcrumbs={[
        { name: "Home", item: "https://aishcraft.com/" },
        { name: "Productivity Planners", item: PAGE_URL },
      ]}
    />
  );

  if (error) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>
      </>
    );
  }

  if (!products) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>
      </>
    );
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/productivityplanner",
    announcement: {
      headline: "New: 2026 Productivity Collection is here!",
      subtext: "Goal trackers, time blocks & project planners",
    },
    hero: {
      title: " Planners",
      subtitle: "Built for people who mean business",
      featuredIn: ["FORBES INDIA", "INC42", "YOUR STORY"],
      quote: "Finally a planner that keeps up with my schedule — and still looks great on my desk.",
      quoteLink: "#",
      rating: "4.8",
      ratingCount: "500+",
    },
  };

  return (
    <>
      {seo}
      <ProductListSchema products={products} pageUrl={PAGE_URL} />
      <FAQSchema faqs={productivityPlannerFAQs} />
      <CollectionPage config={config} />
    </>
  );
}